import React, { useEffect, useState } from 'react';
import { useLocation, useParams, useNavigate } from 'react-router-dom';

const MisskeyCallback: React.FC = () => {
  const { domain_name } = useParams();
  const session = new URLSearchParams(useLocation().search).get('session');
  const navigate = useNavigate();
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!domain_name || !session) { setError(true); return; }
    fetch(`/api/v1/misskey/callback/${domain_name}?session=${session}`)
      .then((r) => {
        if (!r.ok) throw new Error();
        navigate('/mypage');
      })
      .catch(() => setError(true));
  }, [domain_name, session, navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4 text-ink-600 dark:text-ink-300 bg-ink-50 dark:bg-ink-950">
      {error ? (
        <>
          <p className="text-rose-500 font-semibold">認証に失敗しました</p>
          <button
            onClick={() => navigate('/login')}
            className="underline text-sm"
          >
            ログインページへ戻る
          </button>
        </>
      ) : (
        <p className="animate-pulse">Misskey で認証中…</p>
      )}
    </div>
  );
};

export default MisskeyCallback;
